var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.329102 20C0.329102 8.9543 9.28341 0 20.3291 0H60.3191C71.3648 0 80.3191 8.95431 80.3191 20V59.99C80.3191 71.0357 71.3648 79.99 60.3191 79.99H20.3291C9.2834 79.99 0.329102 71.0357 0.329102 59.99V20Z",
    fill: "url(#paint0_linear_193_201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3241 29.1028C41.3551 28.1784 42.5372 27.5696 43.8704 27.2763C45.2036 26.983 46.519 27.0141 47.8167 27.3696C49.1676 27.7429 50.3364 28.4229 51.323 29.4094C52.3095 30.396 52.9895 31.5648 53.3628 32.9157C53.7183 34.2134 53.7494 35.5244 53.4561 36.8487C53.1628 38.173 52.554 39.3595 51.6296 40.4083L40.3241 51.7139L29.0185 40.4083C28.0942 39.3595 27.4854 38.173 27.192 36.8487C26.8987 35.5244 26.9299 34.2134 27.2854 32.9157C27.6587 31.5648 28.343 30.396 29.3385 29.4094C30.334 28.4229 31.4983 27.7429 32.8315 27.3696C34.1291 27.0141 35.4446 26.983 36.7778 27.2763C38.111 27.5696 39.2931 28.1784 40.3241 29.1028ZM49.4165 31.2892C48.7588 30.6315 47.9944 30.1827 47.1234 29.9427C46.2524 29.7027 45.3725 29.6805 44.4837 29.876C43.5949 30.0716 42.8038 30.4804 42.1106 31.1026L40.3241 32.7024L38.5376 31.1026C37.8621 30.4804 37.0755 30.0716 36.1778 29.876C35.2801 29.6805 34.3958 29.7027 33.5247 29.9427C32.6537 30.1827 31.8894 30.6315 31.2316 31.2892C30.5739 31.947 30.1206 32.7113 29.8718 33.5823C29.6229 34.4534 29.5918 35.3288 29.7785 36.2088C29.9651 37.0887 30.3606 37.8753 30.965 38.5685L40.3241 47.9542L49.6831 38.5685C50.2875 37.8753 50.683 37.0887 50.8697 36.2088C51.0563 35.3288 51.0252 34.4534 50.7764 33.5823C50.5275 32.7113 50.0742 31.947 49.4165 31.2892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_201",
    x1: 0.329102,
    y1: 0,
    x2: 80.3191,
    y2: 79.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D9488"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay4);
export default __webpack_public_path__ + "static/media/Overlay-4.a5978da47d9de2544e7a639e509f8e58.svg";
export { ForwardRef as ReactComponent };